module.exports = __webpack_public_path__ + "static/media/like.03ee9e5f.svg";